if (!customElements.get("product-form")) {
    class ProductForm extends HTMLElement {
        constructor() {
            super();
            if (this.hasChildNodes()) this.init();
        }

        init() {
            this.form = this.querySelector(
                ".js-product-form"
            );
            if (this.form) {
                this.form.querySelector(
                    '[name="id"]'
                ).disabled = false;
                this.cartDrawer =
                    document.querySelector("cart-drawer");
                this.submitBtn =
                    this.querySelector('[name="add"]');

                if (theme.settings.afterAtc !== "no-js") {
                    this.addEventListener(
                        "submit",
                        this.handleSubmit.bind(this)
                    );
                }
            }
        }

        /**
         * Handles submission of the product form.
         * @param {object} evt - Event object.
         */
        async handleSubmit(evt) {
            if (evt.target.id === "product-signup_form")
                return;

            evt.preventDefault();

            if (
                this.submitBtn.getAttribute(
                    "aria-disabled"
                ) === "true"
            )
                return;

            if (
                theme.settings.vibrateOnATC &&
                window.navigator.vibrate
            ) {
                window.navigator.vibrate(100);
            }

            this.errorMsg = null;
            this.setErrorMsgState();

            // Disable "Add to Cart" button until submission is complete.
            this.submitBtn.setAttribute(
                "aria-disabled",
                "true"
            );
            this.submitBtn.classList.add("is-loading");

            // prepare form data
            const formData = new FormData(this.form);
            let sections = "cart-icon-bubble";
            if (this.cartDrawer) {
                sections += `,${this.cartDrawer
                    .closest(".shopify-section")
                    .id.replace("shopify-section-", "")}`;
            }
            formData.append(
                "sections_url",
                window.location.pathname
            );
            formData.append("sections", sections);

            // Wrap the submission in the activeRequest promise
            window.activeRequest =
                window.activeRequest.then(async () => {
                    try {
                        const newVariantId = Number(
                            formData.get("id")
                        );
                        const newQuantity = Number(
                            formData.get("quantity") || 1
                        );

                        const response = await fetch(
                            `${window.Shopify.routes.root}cart/add.js`,
                            {
                                method: "POST",
                                headers: {
                                    "Content-Type":
                                        "application/json",
                                },
                                body: JSON.stringify({
                                    id: newVariantId,
                                    quantity: newQuantity,
                                    sections: sections,
                                    sections_url:
                                        window.location
                                            .pathname,
                                }),
                            }
                        );

                        const data = await response.json();

                        if (data.status) {
                            let error =
                                typeof data.description ===
                                "string"
                                    ? data.description
                                    : data.message;
                            if (
                                data.errors &&
                                typeof data.errors ===
                                    "object"
                            ) {
                                error = Object.entries(
                                    data.errors
                                ).map((item) =>
                                    item[1].join(", ")
                                );
                            }
                            this.setErrorMsgState(error);
                            throw new Error("添加商品失败");
                        }

                        if (!response.ok)
                            throw new Error(
                                `添加商品失败: ${response.status}`
                            );

                        if (
                            theme.settings.afterAtc ===
                            "page"
                        ) {
                            setTimeout(() => {
                                window.location.href =
                                    theme.routes.cart;
                            }, 300);
                        } else {
                            ProductForm.updateCartIcon(
                                data
                            );

                            const quickAddDrawer =
                                this.closest(
                                    "quick-add-drawer"
                                );
                            if (quickAddDrawer)
                                quickAddDrawer.addedToCart();

                            setTimeout(() => {
                                if (this.cartDrawer) {
                                    this.cartDrawer.renderContents(
                                        data,
                                        !quickAddDrawer &&
                                            theme.settings
                                                .afterAtc ===
                                                "drawer"
                                    );
                                } else if (
                                    window.location
                                        .pathname ===
                                    theme.routes.cart
                                ) {
                                    const cartItems =
                                        document.querySelector(
                                            "cart-items"
                                        );
                                    if (cartItems) {
                                        if (
                                            cartItems
                                                .dataset
                                                .empty ===
                                            "true"
                                        ) {
                                            window.location.reload();
                                        } else {
                                            cartItems.refresh();
                                        }
                                    }
                                }
                            }, 700);
                        }

                        this.dispatchEvent(
                            new CustomEvent(
                                "on:cart:add",
                                {
                                    bubbles: true,
                                    detail: {
                                        variantId:
                                            newVariantId,
                                        quantity:
                                            newQuantity,
                                    },
                                }
                            )
                        );
                    } catch (error) {
                        console.log(error); // eslint-disable-line
                        this.dispatchEvent(
                            new CustomEvent(
                                "on:cart:error",
                                {
                                    bubbles: true,
                                    detail: {
                                        error: this.errorMsg
                                            ? this.errorMsg
                                                  .textContent
                                            : "添加购物车失败",
                                    },
                                }
                            )
                        );
                    } finally {
                        this.submitBtn.classList.add(
                            "is-success"
                        );
                        this.submitBtn.removeAttribute(
                            "aria-disabled"
                        );
                        setTimeout(() => {
                            this.submitBtn.classList.remove(
                                "is-loading"
                            );
                            this.submitBtn.classList.remove(
                                "is-success"
                            );
                        }, 1400);
                    }
                });
        }

        /**
         * Updates the cart icon count in the header.
         * @param {object} response - Response JSON.
         */
        static updateCartIcon(response) {
            const cartIconBubble = document.getElementById(
                "cart-icon-bubble"
            );
            if (cartIconBubble) {
                cartIconBubble.innerHTML =
                    response.sections["cart-icon-bubble"];
            }
        }


        /**
         * Shows/hides an error message.
         * @param {string} [error=false] - Error to show a message for.
         */
        setErrorMsgState(error = false) {
            this.errorMsg =
                this.errorMsg ||
                this.querySelector(".js-form-error");
            if (!this.errorMsg) return;

            this.errorMsg.hidden = !error;
            if (error) {
                this.errorMsg.innerHTML = "";
                const errorArray = Array.isArray(error)
                    ? error
                    : [error];
                errorArray.forEach((err, index) => {
                    if (index > 0)
                        this.errorMsg.insertAdjacentHTML(
                            "beforeend",
                            "<br>"
                        );
                    this.errorMsg.insertAdjacentText(
                        "beforeend",
                        err
                    );
                });
            }
        }
    }

    customElements.define("product-form", ProductForm);
}
